var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { TokenClient } from '../../services/authentication/token-client.service';
import { bindable } from "aurelia-templating";
import { transient } from "aurelia-dependency-injection";
import { autoinject, noView } from "aurelia-framework";
var AnalyticsCustomAttribute = /** @class */ (function () {
    function AnalyticsCustomAttribute(element, tokenClient) {
        this.element = element;
        this.tokenClient = tokenClient;
    }
    AnalyticsCustomAttribute.prototype.attached = function () {
        if (this.tokenClient && this.tokenClient.user) {
            var brandId = this.tokenClient.user.brandId;
            var playerId = this.tokenClient.user.playerId;
            var category = brandId + '_' + playerId + '_' + this.category;
            this.element.setAttribute('data-analytics-category', category);
            if (this.label)
                this.element.setAttribute('data-analytics-label', this.label);
            if (this.action)
                this.element.setAttribute('data-analytics-action', this.action);
            if (this.value)
                this.element.setAttribute('data-analytics-value', this.value);
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], AnalyticsCustomAttribute.prototype, "category", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], AnalyticsCustomAttribute.prototype, "action", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], AnalyticsCustomAttribute.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], AnalyticsCustomAttribute.prototype, "value", void 0);
    AnalyticsCustomAttribute = __decorate([
        noView(),
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [Element, TokenClient])
    ], AnalyticsCustomAttribute);
    return AnalyticsCustomAttribute;
}());
export { AnalyticsCustomAttribute };
